import { FilteractionObject } from '@yes.technology/react-toolkit'
import apiAsync from 'utils/api-async'

export default async function fetchFilteraction(
  filteractionUuid: unknown,
  showLoading = false,
  throwError = false
): Promise<FilteractionObject | undefined> {
  const response = await apiAsync.requestSync({
    endpoint: 'objects_filter',
    method: 'POST',
    obj: {
      query: {
        'situation.des': {
          $eq: '40'
        },
        'uuid.des': {
          $eq: filteractionUuid
        }
      },
      objectclass: window.idObjectclassFilteraction,
      orderby: [],
      pagination: {
        offset: 0,
        limit: 1
      }
    },
    showLoading,
    throwError
  })

  return response.data.objects?.[0] as FilteractionObject
}
